import BackDropComponent from "@/components/BackDrop";
import { downloadFinalChargesReportRequest, downloadFinalChargesReportReset, fetchBillingDatesRequest, fetchFinalChargeslogRequest, } from "@/redux/actions";
import { formatDateRangeForBillingCycle, getDateString } from "@/utils/Common";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { config } from "../../../config";
import { Box, Button, Chip, Grid, IconButton, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography, } from "@mui/material";
import _ from "lodash";
import { enqueueSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AddRecordSliderbarPage from "./AddRecordSlidebar";
import FinalChargesSliderbarPage from "./FinalChargesSlidebar";
const headCells = [
    {
        id: "tenent",
        disablePadding: true,
        label: "Tenent",
    },
    {
        id: "company",
        disablePadding: true,
        label: "Company",
    },
    {
        id: "accountType",
        disablePadding: true,
        label: "Account type",
    },
    {
        id: "dueShipmentCharges",
        disablePadding: true,
        label: "Due shipment charges",
    },
    {
        id: "codRemittence",
        disablePadding: true,
        label: "COD remittence",
    },
    {
        id: "amountPaidForManifest",
        disablePadding: true,
        label: "Amount paid for manifest",
    },
    {
        id: "finalDeduction",
        disablePadding: true,
        label: "Final deduction",
    },
    {
        id: "finalRemittence",
        disablePadding: true,
        label: "Final remittence",
    },
    {
        id: "finalCollectable",
        disablePadding: true,
        label: "Final collectable",
    },
    {
        id: "remittanceStatus",
        disablePadding: true,
        label: "Remittance status",
    },
    {
        id: "controls",
        disablePadding: true,
        label: "",
    },
];
function EnhancedTableHead(props) {
    return (React.createElement(TableHead, { sx: { p: 2 }, style: { background: "#FAFBFC" } },
        React.createElement(TableRow, null, headCells.map((headCell) => (React.createElement(TableCell, { key: headCell.id, align: "left", className: "orderTable_heading_font" }, headCell.label))))));
}
const FinalChargesPage = () => {
    const [finalCharges, setFinalCharges] = useState([]);
    const [selecteFinalCharges, setSelectedFinalCharges] = useState();
    const [isRightSidebarOpen, setIsRightSidebarOpen] = useState(false);
    const [isExportSidebarOpen, setIsExportSidebarOpen] = useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [nextPage, setNextPage] = React.useState(null); // next page data
    const [isBackOpenOpen, setIsBackOpenOpen] = React.useState(false);
    const open = Boolean(anchorEl);
    const primaryColor = config.theme.primaryColor;
    const id = open ? "simple-popover" : undefined;
    const [page, setPage] = React.useState(0);
    const dispatch = useDispatch();
    const [billingCycles, setBillingCycles] = useState([]);
    const [selectedBillingCycle, setSelectedBillingCycle] = useState("");
    const [totalCount, setTotalCount] = React.useState(0);
    const billingDatesState = useSelector((state) => state.fetchBillingDatesData);
    const finalChargesState = useSelector((state) => state.finalChargesLogReducer);
    const downloadFinalChargesReportState = useSelector((state) => state.downloadFinalChargesReportData);
    React.useEffect(() => {
        if (finalChargesState && _.has(finalChargesState, "data.finalChargesRecords")) {
            if (!_.isEmpty(finalChargesState.data.finalChargesRecords)) {
                setFinalCharges([...finalChargesState.data.finalChargesRecords]);
                setTotalCount(finalChargesState.data.totalRecords);
            }
            setIsBackOpenOpen(false);
        }
        else if (finalChargesState.error) {
            if (finalChargesState.error instanceof Error) {
                enqueueSnackbar(finalChargesState.error.message, {
                    variant: "error",
                });
            }
            setIsBackOpenOpen(false);
        }
    }, [finalChargesState, dispatch]);
    React.useEffect(() => {
        if (billingDatesState && (billingDatesState === null || billingDatesState === void 0 ? void 0 : billingDatesState.data)) {
            const billingDates = billingDatesState.data;
            setBillingCycles(billingDatesState.data);
            setSelectedBillingCycle((billingDates === null || billingDates === void 0 ? void 0 : billingDates.length) > 0 ? billingDates[0] : "");
            setIsBackOpenOpen(false);
        }
        else if (billingDatesState.error) {
            if (billingDatesState.error instanceof Error) {
                enqueueSnackbar(billingDatesState.error.message, {
                    variant: "error",
                });
            }
            setIsBackOpenOpen(false);
        }
    }, [billingDatesState, dispatch]);
    const handleClickPopOver = (event, finalCharge) => {
        setAnchorEl(event.currentTarget);
        setIsExportSidebarOpen(true);
        setSelectedFinalCharges(finalCharge);
    };
    useEffect(() => {
        if (selectedBillingCycle) {
            fetchFinalChargesDetails(rowsPerPage, 0);
        }
    }, [selectedBillingCycle]);
    const fetchFinalChargesDetails = (pageSize, pageNumber) => {
        setIsBackOpenOpen(true);
        dispatch(fetchFinalChargeslogRequest({
            pageSize: pageSize,
            pageNumber: pageNumber ? pageNumber : 0,
            billingCycle: selectedBillingCycle,
        }));
    };
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        if (finalCharges.length / rowsPerPage <= newPage) {
            fetchFinalChargesDetails(rowsPerPage, newPage);
        }
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        setNextPage(null);
        setFinalCharges([]);
        fetchFinalChargesDetails(parseInt(event.target.value, 10));
    };
    React.useEffect(() => {
        setIsBackOpenOpen(true);
        dispatch(fetchBillingDatesRequest({ limit: 10 }));
        setNextPage(null);
    }, []);
    const handleOrderStatusClick = () => {
        setIsBackOpenOpen(true);
        dispatch(downloadFinalChargesReportRequest({
            billingDate: selectedBillingCycle,
        }));
    };
    const handleDownload = (data, extension) => {
        let type = extension === "pdf" ? "application/pdf" : extension === "png" ? "image/png" : `application/${extension}`;
        if (extension === "xlsx")
            type = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const blobData = data instanceof Uint8Array ? new Blob([data], { type }) : data;
        const url = window.URL.createObjectURL(blobData);
        const link = document.createElement("a");
        link.href = url;
        link.download = `report.${extension}`;
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
    };
    React.useEffect(() => {
        if (downloadFinalChargesReportState.data) {
            setIsBackOpenOpen(false);
            handleDownload(downloadFinalChargesReportState.data, "xlsx");
            dispatch(downloadFinalChargesReportReset());
        }
        else if (downloadFinalChargesReportState.error) {
            enqueueSnackbar("Unable to download payment report", {
                variant: "error",
            });
            setIsBackOpenOpen(false);
        }
    }, [downloadFinalChargesReportState]);
    return (React.createElement(Grid, { container: true, direction: "column", sx: { p: 5, height: "calc(100vh - 66px)" }, className: "m_background_color" },
        React.createElement(Grid, { item: true, container: true, mb: 2, gap: 2, sx: { mt: 3 } },
            React.createElement(Grid, null,
                React.createElement(Typography, { sx: {
                        fontFamily: "Poppins",
                        fontSize: "20px",
                        fontWeight: 600,
                        lineHeight: "30px",
                        textAlign: "left",
                        color: "#121114",
                    } }, "Final charges")),
            React.createElement(Grid, { className: "m_border_grey m_bg_wt", sx: { p: 2 }, item: true, xs: 12, container: true, direction: "row", alignItems: "center", justifyContent: "space-between", padding: 1 },
                React.createElement(Grid, { item: true, xs: 3 },
                    React.createElement(Box, { sx: { display: "flex", alignItems: "center", gap: 2 } },
                        React.createElement(Typography, { variant: "body2", sx: {
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                fontSize: "14px",
                                color: "#000000",
                                lineHeight: "21px",
                                whiteSpace: "nowrap",
                            } }, "Billing Cycle"),
                        React.createElement(Select, { fullWidth: true, value: selectedBillingCycle, onChange: (e) => setSelectedBillingCycle(e.target.value), variant: "outlined", size: "small", sx: {
                                backgroundColor: "#fff",
                                borderRadius: 1,
                                "& .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#000000",
                                },
                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#000000",
                                },
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                    borderColor: `${primaryColor} !important`,
                                },
                            } }, billingCycles.map((item, index) => {
                            return (React.createElement(MenuItem, { key: index, value: item },
                                React.createElement(Typography, { variant: "body1", className: "m_font_size_14", style: { color: "#000000" } }, formatDateRangeForBillingCycle(item))));
                        })))),
                React.createElement(Grid, { item: true, container: true, justifyContent: "flex-end", xs: 6 },
                    React.createElement(Grid, { item: true, className: "or_group_button_height" },
                        React.createElement(Button, { variant: "contained", className: "or_group_button_height", size: "small", sx: { textTransform: "none" }, onClick: handleOrderStatusClick },
                            React.createElement("img", { src: require("../../../assets/Onboarding/exportIcon.svg").default, alt: "Export Icon", style: { width: "16px", height: "16px", marginRight: "8px" } }),
                            "Export")))),
            React.createElement(Grid, { container: true, direction: "row", className: "m_background_color" },
                React.createElement(Paper, { sx: { width: "100%", overflowX: "auto" } },
                    React.createElement(TableContainer, null,
                        React.createElement(Table, { sx: { minWidth: 750 }, className: "or_table", "aria-labelledby": "tableTitle", size: "medium" },
                            React.createElement(EnhancedTableHead, { rowCount: finalCharges === null || finalCharges === void 0 ? void 0 : finalCharges.length }),
                            React.createElement(TableBody, null, finalCharges && finalCharges.length > 0 ? (finalCharges.map((row, index) => (React.createElement(TableRow, { hover: true, key: index, role: "checkbox", tabIndex: -1, sx: { cursor: "pointer" } },
                                React.createElement(TableCell, { className: "orderTable_font", align: "left" },
                                    React.createElement(Typography, { variant: "subtitle1", className: "m_font_size_12 orderTable_font", sx: {
                                            wordWrap: "break-word",
                                            textAlign: "left",
                                            overflow: "hidden",
                                            whiteSpace: "nowrap",
                                            textOverflow: "ellipsis",
                                            maxWidth: "160px",
                                        } }, row.tenantId),
                                    React.createElement(Typography, { variant: "body2", className: "orderTable_small_font m_font_size_11" }, row.createdAt ? getDateString(+row.createdAt, "MM-DD-YYYY hh:mm a") : "-")),
                                React.createElement(TableCell, { className: "orderTable_font", align: "left" },
                                    React.createElement(Typography, { variant: "subtitle2", component: "div", className: "orderTable_font", sx: { textAlign: "left" } }, row.companyName)),
                                React.createElement(TableCell, { className: "orderTable_font", align: "left" },
                                    React.createElement(Typography, { variant: "subtitle2", component: "div", className: "orderTable_font", sx: { textAlign: "left" } }, row.accountType === "POSTPAID" ? (React.createElement(Chip, { label: "Postpaid", variant: "outlined", size: "small", sx: {
                                            color: "#404854",
                                            backgroundColor: "#E9E9EC",
                                            borderColor: "#404854",
                                        } })) : (React.createElement(Chip, { label: "Prepaid", variant: "outlined", size: "small", sx: {
                                            color: "#5391A1",
                                            backgroundColor: "#E7F9FE",
                                            borderColor: "#5391A1",
                                        } })))),
                                React.createElement(TableCell, { className: "orderTable_font", align: "left" },
                                    React.createElement(Typography, { variant: "subtitle2", component: "span", className: "orderTable_font", sx: { textAlign: "left" } }, row.dueShipmentCharges)),
                                React.createElement(TableCell, { className: "orderTable_font", align: "left" },
                                    React.createElement(Typography, { variant: "subtitle2", component: "span", className: "orderTable_font", sx: { textAlign: "left" } }, row.codRemittance)),
                                React.createElement(TableCell, { className: "orderTable_font", align: "left" },
                                    React.createElement(Typography, { variant: "subtitle2", component: "div", className: "orderTable_font", sx: { textAlign: "left" } }, row.amountPaidAtManifest)),
                                React.createElement(TableCell, { className: "orderTable_font", align: "left" },
                                    React.createElement(Typography, { variant: "subtitle2", component: "div", className: "orderTable_font", sx: { textAlign: "left" } }, row.finalDeduction)),
                                React.createElement(TableCell, { className: "orderTable_font", align: "left" },
                                    React.createElement(Typography, { variant: "subtitle2", component: "span", className: "orderTable_font", sx: { textAlign: "left" } }, row.finalRemittance)),
                                React.createElement(TableCell, { className: "orderTable_font", align: "left" },
                                    React.createElement(Typography, { variant: "subtitle2", component: "div", className: "orderTable_font", sx: { textAlign: "left" } }, row.finalCollectable)),
                                React.createElement(TableCell, { className: "orderTable_font", align: "left" },
                                    React.createElement(Typography, { variant: "subtitle2", component: "div", className: "orderTable_font", sx: { textAlign: "left" } }, row.processingStatus === "pending" ? (React.createElement(Chip, { label: "Pending", variant: "outlined", size: "small", sx: {
                                            color: "#BB8734",
                                            borderColor: "#BB8734",
                                        } })) : row.processingStatus === "completed" ? (React.createElement(Chip, { label: "Completed", variant: "outlined", size: "small", sx: {
                                            color: "#2B873D",
                                            borderColor: "#2B873D",
                                        } })) : row.processingStatus === "cod_upcoming" ? (React.createElement(Chip, { label: "Cod upcoming", variant: "outlined", size: "small", sx: {
                                            color: "#BB8734",
                                            borderColor: "#BB8734",
                                        } })) : row.processingStatus === "cod_processing" ? (React.createElement(Chip, { label: "Cod processing", variant: "outlined", size: "small", sx: {
                                            color: "#BB8734",
                                            borderColor: "#BB8734",
                                        } })) : (React.createElement(Chip, { label: "Transferred", variant: "outlined", size: "small", sx: {
                                            color: "#2B873D",
                                            borderColor: "#2B873D",
                                        } })))),
                                React.createElement(TableCell, { className: "orderTable_font", align: "center" },
                                    React.createElement(IconButton, { onClick: (event) => handleClickPopOver(event, row) },
                                        React.createElement(MoreVertIcon, null))))))) : (React.createElement(TableRow, null,
                                React.createElement(TableCell, { colSpan: 9, align: "center" }, "No final charges available")))))),
                    React.createElement(TablePagination, { rowsPerPageOptions: [5, 10, 25], component: "div", count: totalCount, rowsPerPage: rowsPerPage, page: page, onPageChange: handleChangePage, onRowsPerPageChange: handleChangeRowsPerPage })))),
        isExportSidebarOpen && selecteFinalCharges && (React.createElement(FinalChargesSliderbarPage, { isOpen: isExportSidebarOpen, setIsExportSidebarOpen: setIsExportSidebarOpen, selecteFinalCharges: selecteFinalCharges, setSelectedFinalCharges: setSelectedFinalCharges, selectedBillingCycle: selectedBillingCycle, setIsBackOpenOpen: setIsBackOpenOpen })),
        isRightSidebarOpen && (React.createElement(AddRecordSliderbarPage, { isOpen: isRightSidebarOpen, setIsRightSidebarOpen: setIsRightSidebarOpen })),
        React.createElement(BackDropComponent, { open: isBackOpenOpen })));
};
export default FinalChargesPage;
